const useScroll = () => {

    return (queryElement, extraSpace = 100, behavior = 'smooth') => {
        var result = document.querySelector(queryElement);
        if (!result) return;
        
        const offSettop = result.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: offSettop - extraSpace, behavior });
    };
};

export default useScroll;